import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../actions/authentication';
import OrganizationSwitch from './OrganizationSwitch';
import withRouter from './WithRouter';

class Topbar extends Component {

  onLogout(e) {
      e.preventDefault();
      this.props.logoutUser(this.props);
  }


  render() {
    const {isAuthenticated, user} = this.props.auth;
    let userfirstletter = ''
    if (user.name) {
      userfirstletter = user.name.charAt(0);
    }
    const authLinks = (
      <div className="wrapper">
        <div className="left">
        <OrganizationSwitch />
        </div>
        <div className="right">
          <div className="user">
            <span className="rounded-circle">
              {userfirstletter}
            </span>
            <p>{user.name}</p>
          </div>
          <a href="#" className="nav-link" onClick={this.onLogout.bind(this)}>
            Logout
          </a>
        </div>
      </div>
    )
    return (
      <div className="topbar">
        {isAuthenticated ? authLinks:''}
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, { logoutUser })(withRouter(Topbar));
